import React, { useState } from "react";

import { createUseStyles } from "react-jss";
import { eventTypes } from "../../../../lib/analytics";
import { isInternalLink } from "../../../../lib/utils";

const truncate = require("truncate");
const ReactMarkdown = require("react-markdown/with-html");
const remarkLinkifyRegex = require("remark-linkify-regex");
const US_CANADA_PHONE_REGEX =
  /^\(?([2-9][0-9]{2})\)?[-. ]?([2-9](?!11)[0-9]{2})[-. ]?([0-9]{4})$/;

const useStyles = createUseStyles((theme) => ({
  showMoreText: { color: "#2499bf", cursor: "pointer" },
  hyperLink: {
    color: theme.primaryColor,
    textDecoration: "underline !important",
  },
}));

const TRUNCATION_LENGTH = 400;

const onLinkClick =
  ({ sendEvent, url }) =>
  () => {
    sendEvent(eventTypes.URL_TAG_CLICK, { url });
  };

const truncateText = (text) =>
  truncate(text, TRUNCATION_LENGTH, { ellipsis: ")." });
export default ({ sendEvent, text, shouldTruncate }) => {
  const [showAll, setShowAll] = useState(false);
  const styles = useStyles();

  const showText = !showAll && shouldTruncate ? truncateText(text) : text;
  const ellipsis = text.length !== truncateText(text).length;

  return (
    <>
      <ReactMarkdown
        source={showText}
        escapeHtml={false}
        astPlugins={[remarkLinkifyRegex(US_CANADA_PHONE_REGEX)()]}
        renderers={{
          link: ({ href, children }) => (
            <a
              className={styles.hyperLink}
              key={"link" + href}
              href={US_CANADA_PHONE_REGEX.test(href) ? "tel:" + href : href}
              target={isInternalLink(href) ? "_top" : "_blank"}
              rel="noopener noreferrer"
              onClick={onLinkClick({ sendEvent, url: href })}
            >
              {children}
            </a>
          ),
        }}
      />
      {ellipsis && shouldTruncate && (
        <span
          className={styles.showMoreText}
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Show less" : "Show more"}
        </span>
      )}
    </>
  );
};
